import React from 'react'
import styled from 'styled-components'

const Overlay = styled.div`
  position: fixed;
  background-color: transparent;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1000000;
`

export default function ScreenshotOverlay({ isVisible }) {
  if (!isVisible) return null

  return <Overlay />
}
